module.exports = __webpack_public_path__ + "img/hitfm.bb5e7eaf.svg";